import { render, staticRenderFns } from "./LicenseAgreementCheckbox.vue?vue&type=template&id=6b21e11b&"
import script from "./LicenseAgreementCheckbox.vue?vue&type=script&lang=js&"
export * from "./LicenseAgreementCheckbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports